<template>
  <div class="telas">
    <div class="mb-2" style="text-align: right">
      <v-btn color="cyan" small dark to="/atena/tela/novo" class="rounded-sm font-weight-regular" width="90px">Novo</v-btn>
    </div>

    <FiltroTable ref="filtro" :options="optionsBusca" :quantidadeResultados="paginaTotal" @filtro="filtroRegistros" />

    <v-alert type="error" v-if="telas.length <= 0" value="true" dark class="mt-3 mb-3">
      <div>Nenhuma tela cadastrada!</div>
    </v-alert>
    <v-card v-else style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>
            <th>Código</th>
            <th>Descrição</th>
            <th>Grupo</th>
            <th>Url</th>
            <th>Funções</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tela in telas" :key="tela.identificadortela">
            <td class="centro">{{ tela.identificadortela }}</td>
            <td>{{ tela.descricaotela }}</td>
            <td>{{ tela.grupo.descricaotelagrupo }}</td>
            <td class="centro">{{ tela.url }}</td>
            <td class="centro">
              <v-tooltip bottom style="flex: 1">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ tela.tela_funcoes.length }}
                  </span>
                </template>
                <span>
                  <div v-for="key in tela.tela_funcoes" :key="key.id">
                    <i>{{ key.descricaofuncao }}</i>
                  </div>
                </span>
              </v-tooltip>
            </td>
            <td class="centro">
              <v-btn icon title="Permissões" class="aulas-btn-acao" :to="{ path: `/atena/tela/${tela.identificadortela}/permissoes` }">
                <v-icon class="btn-acoes-icon">enhanced_encryption</v-icon>
              </v-btn>
              <v-btn icon title="Editar" class="aulas-btn-acao" :to="{ path: `/atena/tela/${tela.identificadortela}` }">
                <v-icon class="btn-acoes-icon">edit</v-icon>
              </v-btn>
              <v-btn icon title="Excluir" class="aulas-btn-acao" @click="excluir(tela.identificadortela)">
                <v-icon color="red">delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="quantidadePaginas > 1" class="table-siged-page" style="text-align: right">
        <v-pagination v-model="paginaAtual" :length="quantidadePaginas" total-visible="7" />
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import FiltroTable from '@/components/FiltroTable';

const AtenaTelaRepository = RepositoryFactory.get('atenaTela');

export default {
  name: 'Tela',
  components: {
    FiltroTable,
  },
  data() {
    return {
      telas: [],
      paginaAtual: 1,
      paginaTotal: 0,
      filtroBusca: [],
      quantidadePaginas: 0,
      snackbar: false,
      submitText: '',
      optionsBusca: [
        { text: 'Descrição', value: 'descricaotela', type: "text" },
        { text: 'Código', value: 'identificadortela', type: "number" },
      ],
    };
  },
  watch: {
    paginaAtual() {
      this.reload();
    }
  },
  async beforeRouteEnter(to, from, next){
    const { data } = await AtenaTelaRepository.getListaTelas();

    next(vm => vm.reload(data));
  },
  methods: {
    async reload(data = null) {
      if(!data) {
        this.$Progress.start();
        const retorno = await AtenaTelaRepository.getListaTelas({ page: this.paginaAtual, ...this.filtroBusca });
        data = retorno.data;
      }
      this.paginaAtual = data.results.current_page;
      this.telas = data.results.data;
      this.quantidadePaginas = data.results.last_page;
      this.paginaTotal = data.results.total;

      this.$Progress.finish();
    },
    async filtroRegistros(data) {
      this.paginaAtual = 1;
      this.$refs.filtro.exibirFiltro = false;
      this.filtroBusca = data.filtro;
      await this.reload();
      this.$refs.filtro.exibirFiltro = data.exibir;
    },
    async excluir(id) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este tela?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await AtenaTelaRepository.deleteTela(id);

        this.submitText = data.message;
        this.snackbar = true;
        if(this.paginaAtual > 1 && this.telas.length == 1) { this.paginaAtual--; }
        this.reload();
      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
  },
}
</script>

<style lang="scss">
.telas {
  margin: 0px 15px;

  .aulas-btn-acao {
    margin: 0px;
    color: #4e4e4e!important;
  }
}
</style>
